import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/corporation';

export class CorporationService extends RestServiceConnection {

    listCorporations = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listCorporationsForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-corporations-for-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    listProvidingCorporations = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-providing-corporations',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getCorporationById = async (corporationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { corporationId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    toggleCorporationStatus = async (corporationId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { corporationId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createCorporation = async (user: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editCorporation = async (user: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: user,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    updateCorporationContractAssets = async (
        corporationId: string,
        assets: { contractLogo?: File | null; contractSignature?: File | null; contractSeal?: File | null }
    ) => {
        const formData = new FormData();
        formData.append('corporationId', corporationId);

        if (assets.contractLogo) {
            formData.append('contractLogo', assets.contractLogo);
        }

        if (assets.contractSignature) {
            formData.append('contractSignature', assets.contractSignature);
        }

        if (assets.contractSeal) {
            formData.append('contractSeal', assets.contractSeal);
        }

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/update-contract-assets',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }

    deleteCorporation = async (corporationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { corporationId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteMultiCorporations = async (usersIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { usersIds }
        }, true);
        return this;
    }

}
